<template>
  <div
    class="debug-auth"
    :class="{ hidden: !showLogs }"
  >
    <button
      class="debug-auth__toggle"
      @click="showLogs = !showLogs"
    >
      {{ showLogs ? 'Hide' : 'Show' }} Logs
    </button>

    <div
      v-if="showLogs"
      data-testid="debug-info"
    >
      <div>
        tokenExpiry: expires in {{ tokenExpiry }}s |
        silentRefreshAccessTokenTime: refresh the token when {{ silentRefreshAccessTokenTime }}s left
      </div>
      Warn users of being logged out when {{ inactivityTimerReminder }} seconds left on inactivity timer.
      <div>
        Inactivity timer:
      </div>
    </div>

    <div v-show="showLogs">
      <div v-if="timerIsActive">
        <v-idle
          :loop="false"
          :duration="inactivityTimerReminder"
          @idle="onIdle"
        />
      </div>
    </div>

    <SessionExpiryModal :restart-idle-timer="startTimer" />
  </div>
</template>

<script>
import moment from 'moment';
import SessionExpiryModal from "./SessionExpiryModal";
import authConfig from "~/constants/authConfig";
import getAccessToken from "~/constants/getAccessToken";

let intervalTimer;

export default {
  components: {
    SessionExpiryModal
  },
  data() {
    return {
      tokenExpiry: null,
      timerIsActive: true,
      silentRefreshAccessTokenTime: authConfig.silentRefreshAccessTokenTime,
      inactivityTimerReminder: authConfig.inactivityTimerReminder,
      showLogs: false
    };
  },

  computed: {
    triggerTokenRefresh() {
      return this.tokenExpiry != null &&
          this.tokenExpiry < this.silentRefreshAccessTokenTime;
    }
  },

  mounted() {
    this.checkToken();

    this.$store.commit('notifications/RESET_STORE');
    this.$store.dispatch('notifications/INITIALISE_PUSHER_LISTENER', this.$echo);
    this.$store.commit(
        'notifications/SET_NOTIFICATION_COUNT',
        this.$auth.user.unread_notifications_count
    );

    intervalTimer = window.setInterval(() => {
      this.checkToken();
    }, authConfig.accessTokenExpiryCheckInterval * 1000);
  },

  beforeUnmount() {
    clearInterval(intervalTimer);
  },

  methods: {
    checkToken() {
      const token = getAccessToken();
      if (token) {
        this.tokenExpiry = token.exp - moment().unix();
        if (this.triggerTokenRefresh) {
          this.refreshToken();
        }
      } else if (this.showLogs) {
        console.warn('[checkToken] No access token found');
      }
    },

    onIdle() {
      this.timerIsActive = false;
      this.$events.fire('openSessionExpiryModal');
    },

    async refreshToken() {
      try {
        const response = await this.$api.getRefreshToken();
        const newToken = response?.data?.meta?.token;
        if (newToken) {
          this.$auth.setUserToken(newToken);
        } else {
          await this.$router.push('/redirector');
        }
      } catch (error) {
        await this.$router.push('/redirector');
      }
    },

    startTimer() {
      this.inactivityTimerReminder = authConfig.inactivityTimerReminder;
      this.timerIsActive = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.debug-auth {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.8;
  color: white;
  z-index: 100;
  background-color: black;
  border: 1px red solid;
  padding: 1em;
  padding-top: 20px;
  font-size: 11px;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &.hidden {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
    pointer-events: none;
  }
}

.debug-auth__toggle {
  position: absolute;
  top: 4px;
  right: 6px;
  background: transparent;
  border: none;
  color: inherit;
  font-size: 10px;
  cursor: pointer;
}
</style>
